import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { buildComboPreamble, ComboPreviousStep, FLEXIBLE_COMBO_PREAMBLE } from '../../../utils/combo-context'
import { ComboStepConfig } from '../shared/combo-types'
import { ComboWizardData } from '../shared/combo-wizard-props'
import { FlexibleSpreadDef, getFlexibleSpread } from './spread-registry'

export const FLEXIBLE_COMBO_NAME = 'Combo de lecturas'

export const buildFlexibleSteps = (spreadIds: string[]): ComboStepConfig[] =>
    spreadIds.map((id, index) => {
        const spread = getFlexibleSpread(id)
        if (!spread) {
            throw new Error(`Lectura no encontrada en el registry: ${id}`)
        }
        return {
            step: index + 1,
            type: `combo-flexible-${spread.id}`,
            title: spread.title,
            shortTitle: spread.shortTitle,
            spreadId: spread.id,
            cardCount: spread.cardCount,
            requiresPersonalityNumerology: spread.requiresPersonalityNumerology,
            isLoveMultimodal: spread.isLoveMultimodal,
            needsConsultado: spread.needsConsultado,
        }
    })

export const createFlexibleInterpretStep = (spreads: FlexibleSpreadDef[]) => {
    return (
        step: number,
        cards: AllCardsType[],
        data: ComboWizardData,
        user: string,
        personality: NombreTarotista,
        previousSteps: ComboPreviousStep[],
        comboId: string
    ) => {
        const spread = spreads[step - 1]
        if (!spread) {
            throw new Error(`Paso inválido del combo flexible: ${step}`)
        }

        const preamble = buildComboPreamble(
            FLEXIBLE_COMBO_NAME,
            step,
            spreads.length,
            previousSteps,
            FLEXIBLE_COMBO_PREAMBLE
        )

        const base = spread.interpret(cards, data, user, personality, `combo-flexible-${spread.id}`)

        return {
            ...base,
            consult: preamble + String(base.consult),
            comboId,
            comboName: FLEXIBLE_COMBO_NAME,
            comboStep: step,
            comboTotalSteps: spreads.length,
            type: `combo-flexible-${spread.id}`,
        }
    }
}
